angular.module("rental", ["core"])
    .constant("RentalAgreementConst", {
        eventUpdate: "rental-agreement.update",
        RoleModule: "ROLE_RENTAL_MODULE",
        RoleAgreementRead: "ROLE_RENTAL_MODULE",
        RoleAgreementWrite: "ROLE_RENTAL_AGREEMENT_WRITE",
    })
    .factory("RentalAgreement", function ($resource) {
        return $resource("/crm/api/rental-agreement/:id", {id: "@id"}, {
            table: {method: 'GET', isArray: false, url: '/crm/api/rental-agreement/table'},
            tableStatistics: {method: 'GET', isArray: false, url: '/crm/api/rental-agreement/table-statistics'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            annexes: {method: 'GET', isArray: true, url: '/crm/api/rental-agreement/:id/annexes'},
            items: {method: 'GET', isArray: true, url: '/crm/api/rental-agreement/:id/items'},
            itemSave: {method: 'POST', url: '/crm/api/rental-agreement/:id/items'},
            itemUpdate: {method: 'PUT', url: '/crm/api/rental-agreement/:id/items/:itemId', params: {id: '@id', itemId: '@itemId'}},
            itemDelete: {method: 'DELETE', url: '/crm/api/rental-agreement/:id/items/:itemId', params: {id: '@id', itemId: '@itemId'}},
            itemIndexation: {method: 'POST', url: '/crm/api/rental-agreement/:id/items/:itemId/indexation', params: {id: '@id', itemId: '@itemId'}},
            itemClose: {method: 'POST', url: '/crm/api/rental-agreement/:id/items/:itemId/close', params: {id: '@id', itemId: '@itemId'}},
        });
    })
    .service('RentalAgreementService', function (modals, $rootScope, RentalAgreement, RentalAgreementConst) {
        this.add = params => {
            let entity = {
                id: null,
                items: []
            }
            angular.extend(entity, params)
            return this.edit(entity)
        }
        this.edit = entity => {
            modals.open('app/rental/agreement/edit-modal.html', 'RentalAgreementEditController', angular.copy(entity), {size: 'lg'}, "$ctrl")
        }
        this.open = id => {
            RentalAgreement.get({id: id}).$promise.then(entity => this.show(entity))
        }
        this.show = entity => {
            modals.open('app/rental/agreement/show-modal.html', 'RentalAgreementShowController', angular.copy(entity), {size: 'lg'}, "$ctrl")
        }
        this.delete = entity => {
            return modals.confirmDelete("wybrany rekord", () => RentalAgreement.delete({id: entity.id}).$promise.then(() => $rootScope.$broadcast(RentalAgreementConst.eventUpdate)));
        }
        this.sumItems = (items) => {
            return items.reduce((acc, item) => this.decimalAdd(acc, item.priceTotal), 0)
        }
        this.decimalMultiply = (value, multiplier) => {
            if (value === null || value === undefined) {
                return null
            }
            if (multiplier === null || multiplier === undefined) {
                return null
            }
            return Math.round(value * 100 * multiplier) / 100
        }
        this.decimalAdd = (value, add) => {
            return Math.round(value * 100 + add * 100) / 100
        }
    })
    .config(function ($stateProvider, RentalAgreementConst) {
        $stateProvider.state('rentalAgreementList', {
            parent: 'app',
            url: '/rental-agreement?{page:int}&{size:int}&{sort:string}&{search:string}&signingDateStart&signingDateEnd&periodStart&periodEnd&category&project&costCenter&costType&filesCountFilter&parentFilter',
            data: {
                authorities: [RentalAgreementConst.RoleAgreementRead]
            },
            params: {
                status: {array: true, value: [], squash: false},
            },
            views: {
                'content@': 'rentalAgreementList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (RentalAgreement, $stateParams) => RentalAgreement.table(angular.copy($stateParams)).$promise,
                statistics: (RentalAgreement, $stateParams) => RentalAgreement.tableStatistics(angular.copy($stateParams)).$promise,
            }
        })
        $stateProvider.state('rentalAgreementShow', {
            parent: 'app',
            url: '/rental-agreement/{id}',
            data: {
                authorities: [RentalAgreementConst.RoleAgreementRead]
            },
            views: {
                'content@': 'rentalAgreementShow'
            },
            resolve: {
                item: (RentalAgreement, $stateParams) => RentalAgreement.get({id: $stateParams.id}).$promise
            }
        });
    })

